export const lotConfigurationTabKeys = [
  "settings",
  "priceSetup",
  "display",
  "contactpersons",
  "cameras",
  "connections",
  "contract",
  "businessmodel",
  "autopass"
] as const;

export type LotConfigurationTabKey = (typeof lotConfigurationTabKeys)[number];
